import React, { useState } from "react";
import { useSelector } from "react-redux";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import IconHolder from "../../Resources/svg/Icons/IconHolder";
import IconInformation from "../../Resources/svg/Icons/IconInformation";
import IconMoney from "../../Resources/svg/Icons/IconMoney";
import IconProtection from "../../Resources/svg/Icons/IconProtection";
import SkeletonElement from "../SkeletonElement";
import Flags from "./Flags";
import { handleState } from "../../Utils/utils";
import { useLocation } from "react-router-dom";
import IconWarning40 from "../../Resources/svg/Icons/IconAlert";
import IconAdjuntar from "../../Resources/svg/Icons/IconAdjuntar";
import ModalAttach from "../modalAttach";
import { isUnderage } from "../../Utils/validators";

export function ComparativeIcon(data: any) {
  const { title } = data;

  if (title === "DATOS DE REVISIÓN") {
    return <IconMoney />;
  }

  if (title === "DATOS DE COTIZACIÓN" || title === "DATOS DE SIMULACIÓN" ) {
    return <IconMoney />;
  }

  if (title === "DATOS DEL CONTRATANTE" || title === "DATOS DE LA PENSIÓN" || 'FECHA DE SIMULACION') {
    return <IconHolder />;
  }

  if (title === "DATOS DEL CONTRATANTE*") {
    return <IconHolder />;
  }

  if (title === "DATOS DE BENEFICIARIOS") {
    return <IconProtection />;
  }

  return "";
}

const CardAprobar = ({ loading, data, codigoPorducto, dataAdjuntar, showFile }: any) => {
  const [openModalAttach, setOpenModalAttach] = useState(false);
  const [cotiData, setCotiData] = useState({});
  const capabilities = useSelector((state: any) => (state.login.access_configuration && state.login.access_configuration.capabilities));

  const { title, info, items, beneficiary } = data;

  let herederos = beneficiary.length === 0 ? true : false;
  let arrProducto = [
    "Inversión Global",
    "Ahorro Seguro",
    "Inversión Global Ultra Cash",
    "Renta Garantizada",
  ];

  const handleOpenModalAttach = (data: any) => {
    setOpenModalAttach(true);
    document.body.style.overflow = "hidden";
    setCotiData(data);
  };
  const validateData = showFile ? dataAdjuntar : cotiData;
  return (
    <div className={"card-verify " + `${""}`}>
      <div className="card-verify__header">
        <ComparativeIcon title={title} />
        <div className="card-verify__title">{title}</div>
      </div>
      {items.map(({ quote, data, label, adjuntar }: any, index: number) => {
        return (
          data !== "" && (
            <div key={index} className="card-verify__body">
              <div className="card-verify__quote">
                {data ? (quote ? `${quote}:` : quote) : null}
              </div>
              {loading ? (
                <SkeletonElement type="table-pagination" />
              ) : (
                <div
                  className={`card-verify__data ${
                    arrProducto.includes(data) ? "is-label" : ""
                  }`}
                >
                  {label ? (
                    <Flags variant={data}>{handleState(data)}</Flags>
                  ) : (
                    data
                  )}
                </div>
              )}
              {
              ["RG"].includes(codigoPorducto) && adjuntar && showFile && capabilities.canUploadVoucher && (
                
                <div className="card-verify__adjuntar">
                  <div className="box">
                    <div className="box__icon">
                      <IconWarning40 />
                    </div>
                    <div className="box__text">
                      Si el cliente pagó sin usar el código, deberás adjuntar el
                      voucher.
                      <div
                        className="box__click"
                        onClick={() => handleOpenModalAttach(items)}
                      >
                        <IconAdjuntar /> <span>Adjuntar</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        );
      })}
      {info && (
        <div className="card-verify__information">
          <IconInformation />
          El contratante es la persona que es el titular de la póliza y
          asegurado a la vez.
        </div>
      )}

      {herederos && items.length === 0 ? (
        <>
          {loading ? (
            <SkeletonElement type="table-pagination" />
          ) : (
            <div className="card-verify__data-heredero">Herederos legales.</div>
          )}
        </>
      ) : (
        beneficiary.map(
          ({ nombre, apellido, tipoDoc, dni, relacion, beneficio, fecNacimiento, sexo, numCelular, correoElectronico }: any, index: number) => (
            <div key={index} className="card-verify__beneficiary">
              <div className="clientForm__beneficiary-box-icon">
                <IconBeneficiario />
                <div className="clientForm__beneficiary">
                  Beneficiario {index + 1}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">
                  {tipoDoc === "1" ? "CE" : tipoDoc === "2" ? "DNI" : "PASAPORTE"}:
                </div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{dni}</div>
                )}
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Nombres:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{nombre}</div>
                )}
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Apellidos:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{apellido}</div>
                )}
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Fecha de Nacimiento:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{fecNacimiento ? fecNacimiento : '--'}</div>
                )}
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Sexo:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{sexo}</div>
                )}
              </div>
              {/* { fecNacimiento && !isUnderage(fecNacimiento) && <div className="card-verify__body">
                <div className="card-verify__quote">Celular:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{numCelular}</div>
                )}
              </div> }
              { fecNacimiento && !isUnderage(fecNacimiento) && <div className="card-verify__body">
                <div className="card-verify__quote">Correo electrónico:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{correoElectronico}</div>
                )}
              </div> } */}
              <div className="card-verify__body">
                <div className="card-verify__quote">Relación:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{relacion}</div>
                )}
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">% de beneficio:</div>
                {loading ? (
                  <SkeletonElement type="table-pagination" />
                ) : (
                  <div className="card-verify__data">{beneficio}%</div>
                )}
              </div>
            </div>
          )
        )
      )}

      <ModalAttach
        data={validateData}
        open={openModalAttach}
        setOpen={setOpenModalAttach}
      />
    </div>
  );
};

export default CardAprobar;
